export function sortByProp<K extends string>(propName: K) {
    return <T extends Record<K, string>>(arr: T[]) =>
        arr.slice().sort((a: T, b: T) => {
            if ((a[propName] === '' || a[propName] === null) && (b[propName] === '' || b[propName] === null)) {
                return 0;
            } else if ((a[propName] === '' || a[propName] === null)) {
                return 1;
            } else if (b[propName] === '' || b[propName] === null) {
                return -1;
            } else {
                return (a[propName] ?? '').localeCompare(b[propName] ?? '');
            }
        });
}
